import {appUrls} from "../helpers/Urls";
import axiosInstance from "../utils/axiosInstance";

const getAgentInfo = async ()=>{
    const {data} = await axiosInstance.get(appUrls.currentUser);
    return data
}
export default getAgentInfo